import styled from 'styled-components';

import { Button as BasicButton } from 'components/Button';

const Container = styled.div`
  display: flex;

  gap: 1.2rem;
`;

const Button = styled(BasicButton)`
  padding: 0.5rem;
`;

export { Container, Button };
